type Child = Node | string | null | undefined | false;

// Builds an element. Children are appended as nodes or text, never parsed as HTML; HTML-parsing props throw.
export function h<K extends keyof HTMLElementTagNameMap>(tag: K, props: Record<string, unknown> = {}, ...children: Child[]): HTMLElementTagNameMap[K] {
  const el = document.createElement(tag);
  for (const [key, value] of Object.entries(props)) {
    if (/^(innerHTML|outerHTML|srcdoc)$/.test(key)) throw new Error("unsafe prop " + key);
    if (value === undefined || value === null || value === false) continue;
    if (key === "class") el.className = String(value);
    else if (key.startsWith("on") && typeof value === "function") el.addEventListener(key.slice(2).toLowerCase(), value as EventListener);
    else if (key in el) (el as unknown as Record<string, unknown>)[key] = value;
    else el.setAttribute(key, String(value));
  }
  for (const child of children) if (child) el.append(child);
  return el;
}

export function mount(parent: Element, ...children: Child[]): void {
  parent.replaceChildren(...(children.filter(Boolean) as (Node | string)[]));
}
